module.exports = __webpack_public_path__ + "img/gl.73ae82a7.svg";